import { Component, h } from 'preact'
import { isInputEl } from '../../libs/preact-entry'
import InputGroup from '../ui-components/InputGroup'
import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import { ItemsList, Item } from '../dropdown/interfaces'
import { IdeaStatus } from '../ideation-status/Types'
import axios from 'axios'

interface Props {
  title: string,
  column_1: number,
  column_2: number,
  column_3: number,
  maxHeight: number,
  onChange: (state: {title: string, column_1: number, column_2: number, column_3: number, maxHeight: number}) => void
}

interface State {
  title: string,
  column_1: number,
  column_2: number,
  column_3: number,
  maxHeight: number
  ideaStatusList: Array<IdeaStatus>
}

export class PipelineConfigurator extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      title: props.title,
      column_1: props.column_1,
      column_2: props.column_2,
      column_3: props.column_3,
      maxHeight: props.maxHeight,
      ideaStatusList: []
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  async componentDidMount () {
    const { data } = await axios.get('/community/api/ideas/ideaStatuses')
    if (!data.result.length) {
      return
    }

    this.setState({ ideaStatusList: data.result })
  }
  
  onChangeTitle (newTitle: string) {
    this.setState({
      title: newTitle
    }, this.notifyChanges)
  }

  onChangeMaxHeight(mh: number) {
    this.setState({
      maxHeight: mh
    }, this.notifyChanges)
  }

  onChangeColumn (key: 'column_1'| 'column_2' | 'column_3', value: number) {
    // @ts-ignore
    this.setState({[key]: value}, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange(this.state)
  }

  ideationStatuses (onChange: (value: string) => void) {
    return this.state.ideaStatusList.map((status: IdeaStatus) => {
      return {
        value: status.id,
        title: status.name,
        onClick: (e: Event) => onChange((e.target as HTMLElement).getAttribute('value') as string),
        variant: 'primary'
      } as Item
    })
  }

  getIdeationStatusDropdownTitle (column: number) {
    const items: Array<IdeaStatus> = this.state.ideaStatusList.filter((status: IdeaStatus) => status.id == column.toString())

    if (items.length < 1) {
      return 'Choose ideation status'
    }

    return items[0].name
  }

  render (props: Props, {title, column_1, column_2, column_3, maxHeight} : State) {
    return (
      <div class='pipeline-widget__configurator'>
        <InputGroup
          title='Title'
          type='text'
          qaClasses='qa-most-liked-widget__title'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />
          <InputGroup title={'Ideation status for first column'} customInput={
            <DropdownControl
            triggerClass={'ideation-status-dropdown form-group'}
            align='adjust'
            // @ts-ignore
            trigger={<ButtonControl 
            title={this.getIdeationStatusDropdownTitle(column_1)} 
            icon={'arrowDropdown'} />}
            items={this.ideationStatuses((value: string) => this.onChangeColumn('column_1', parseInt(value))) as ItemsList}
            hasSearch={false}
          />
          } />
          <InputGroup title={'Ideation status for second column'} customInput={
            <DropdownControl
            triggerClass={'ideation-status-dropdown form-group'}
            align='adjust'
            // @ts-ignore
            trigger={<ButtonControl 
            title={this.getIdeationStatusDropdownTitle(column_2)} 
            icon={'arrowDropdown'} />}
            items={this.ideationStatuses((value: string) => this.onChangeColumn('column_2', parseInt(value))) as ItemsList}
            hasSearch={false}
          />
          } />
          <InputGroup title={'Ideation status for third column'} customInput={
            <DropdownControl
            triggerClass={'ideation-status-dropdown form-group'}
            align='adjust'
            // @ts-ignore
            trigger={<ButtonControl 
            title={this.getIdeationStatusDropdownTitle(column_3)} 
            icon={'arrowDropdown'} />}
            items={this.ideationStatuses((value: string) => this.onChangeColumn('column_3', parseInt(value))) as ItemsList}
            hasSearch={false}
          />
          } />
          
          <div class='ideation-pipeline__max-list-height'>
            <p class='ideation-pipeline__max-list-height-text'>
              <label>Maximum list height</label>
              <span>
                <input
                  type='number'
                  onChange={(e) => {
                    if (!isInputEl(e.target)) return
                    this.onChangeMaxHeight(parseInt(e.target.value, 10))
                  }}
                  value={maxHeight}
                  min={0} />
                px
              </span>
            </p>
          </div>

      </div>
    )
  }
}

export default PipelineConfigurator
